import React, { ReactNode } from 'react';

import { styled } from '../theme';
import Button from './Button';
import Popover from './Popover';

const ContentContainer = styled('div')<{ isResetOption: boolean }>(({ theme, isResetOption }) => ({
    display: 'flex',
    flexFlow: 'column',
    margin: '4px 0px',
    marginTop: isResetOption ? '50px' : '4px',
    '&& > *': {
        padding: '13px 20px',
        margin: 0,
        ':hover': {
            background: theme.color.surface,
        },
    },
}));

const ResetButton = styled(Button)(({ theme }) => ({
    margin: 0,
    position: 'absolute',
    top: 0,
    ':hover': {
        color: theme.color.primary1,
    },
}));

/**
 * Component
 */
type Option = Record<'value' | 'label', string>;

type Props = Pick<
    React.ComponentProps<typeof Popover>,
    'placement' | 'disableHideOnInnerClick' | 'disableHideOnOuterClick'
> &
    Pick<React.ComponentProps<typeof Button>, 'color'> & {
        disabled: any;
        children: any;
        options: Option[];
        color;
        renderOption: (option: Option) => ReactNode;
        customResetBtn?: () => ReactNode;
        onReset?: () => void;
        isResetDisabled?: boolean;
        buttonStyle?: React.CSSProperties;
    };

const ButtonDropdown2 = <T extends any>({
    children,
    disabled,
    options,
    renderOption,
    placement,
    color,
    buttonStyle,
    onReset,
    isResetDisabled,
    customResetBtn,
    ...props
}: Props) => {
    const renderContent = () => (
        <ContentContainer isResetOption={!!onReset}>
            {onReset &&
                (customResetBtn ? (
                    customResetBtn()
                ) : (
                    <ResetButton disabled={isResetDisabled} color="primary" onClick={onReset}>
                        {/* @todo: add property 'label' */}
                        Revert to Default
                    </ResetButton>
                ))}
            {options.map((option) => renderOption(option))}
        </ContentContainer>
    );
    return (
        <>
            <Popover placement={placement} renderContent={renderContent} {...props}>
                {({ ref, toggleVisibility }) => (
                    <Button
                        disabled={disabled}
                        ref={ref}
                        color={color}
                        type="button"
                        onClick={toggleVisibility}
                        style={buttonStyle}
                    >
                        {children}
                    </Button>
                )}
            </Popover>
        </>
    );
};

export default ButtonDropdown2;
